// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__5tPVb","Image":"Loader_Image__Bd5cV","rotation":"Loader_rotation__zW3DX"};